exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-transparent {\n  background-color: #ececec !important;\n  color: rgba(0, 0, 0, 0.67); }\n\n.cancel-label {\n  min-width: 120px;\n  display: inline-block; }\n\n.pause-icon {\n  vertical-align: middle;\n  padding: 6px 0px 2px 4px; }\n  .pause-icon i {\n    font-size: 20px;\n    color: #e0124d; }\n\n.label {\n  padding: .3em .6em .3em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/client/components/call/list/call-list.component.scss
// module id = ../../../../../src/app/client/components/call/list/call-list.component.scss
// module chunks = 0